import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UIState {
  isSidebarOpen: boolean
  theme: 'light' | 'dark'
  notification: {
    message: string
    type: 'success' | 'error' | 'info' | 'warning'
  } | null
}

const initialState: UIState = {
  isSidebarOpen: true,
  theme: 'light',
  notification: null,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload
    },
    showNotification: (state, action: PayloadAction<{ message: string; type: 'success' | 'error' | 'info' | 'warning' }>) => {
      state.notification = action.payload
    },
    hideNotification: (state) => {
      state.notification = null
    },
  },
})

export const { toggleSidebar, setSidebarOpen, setTheme, showNotification, hideNotification } = uiSlice.actions
export default uiSlice.reducer
